import { getJSON } from "../apiUtils";
import { GetRedirectUrlQueryType } from "@whatslly/types/GetRedirectUrlQuery";
import { GetRedirectUrlResponseType } from "@whatslly/types/GetRedirectUrlResponse";
import { AppIds, LoginProviderType } from "@whatslly/types/LoginProviderType";
import { FrontLogger } from "../frontLogger/frontLogger";

export const getRedirectUrl = async ({
  data,
  logger,
  // POD is hardcoded here since we access our own SF istances befor login
  pod = import.meta.env.VITE_API_DEFAULT_POD?.toString() ?? "us1",
  extId,
  tabId,
  transactionId,
  throwError,
  fetchMethod,
}: {
  logger?: Pick<FrontLogger, "error">;
  data: GetRedirectUrlQueryType & { type: LoginProviderType };
  pod?: string;
  extId?: string;
  tabId?: number;
  transactionId?: string;
  throwError?: boolean;
  fetchMethod?: any;
}) => {
  try {
    const urlSearchParams = new URLSearchParams();
    if (data.email) {
      urlSearchParams.set("email", data.email);
    }
    if (data.userPhone !== undefined) {
      urlSearchParams.set("userPhone", data.userPhone);
    }
    if (data.domain) {
      urlSearchParams.set("domain", data.domain);
    }
    if (data.chatApp) {
      urlSearchParams.set("chatApp", data.chatApp);
    }
    if (data.loginSource) {
      urlSearchParams.set("loginSource", data.loginSource);
    }
    if (data.inviteToken) {
      urlSearchParams.set("inviteToken", data.inviteToken);
    }
    if (extId) {
      urlSearchParams.set("extId", extId);
    }
    if (tabId) {
      urlSearchParams.set("tabId", String(tabId));
    }
    if (transactionId) {
      urlSearchParams.set("transactionId", transactionId);
    }

    let response: Promise<Response>;
    switch (data.type) {
      case AppIds.MICROSOFT_DYNAMICS:
        response = getJSON({ urlSuffix: `/dynamics/auth/redirect?${urlSearchParams.toString()}`, pod, fetchMethod });
        break;
      case AppIds.HUBSPOT:
        response = getJSON({ urlSuffix: `/hubspot/auth/redirect?${urlSearchParams.toString()}`, pod, fetchMethod });
        break;
      case AppIds.GOOGLE:
        urlSearchParams.set("appName", AppIds.GOOGLE);
        urlSearchParams.set("userId", "");
        response = getJSON({ urlSuffix: `/integrations/auth/redirect?${urlSearchParams.toString()}`, pod, fetchMethod });
        break;
      case AppIds.MICROSOFT:
        urlSearchParams.set("appName", AppIds.MICROSOFT);
        urlSearchParams.set("userId", "");
        response = getJSON({ urlSuffix: `/integrations/auth/redirect?${urlSearchParams.toString()}`, pod, fetchMethod });
        break;
      case AppIds.SALESFORCE:
      default:
        response = getJSON({ urlSuffix: `/sfdc/v2/auth/redirect?${urlSearchParams.toString()}`, pod, fetchMethod });
        break;
    }

    const res: GetRedirectUrlResponseType = await (await response).json();
    if (res && res.success && res.url) {
      // Always return object format for consistency
      return { url: res.url, useBrowser: res.useBrowser ?? false };
    }
    if (!res.success && throwError) {
      throw new Error();
    }
  } catch (err) {
    logger?.error({ err }, "failed to get redirect url");
    if (throwError) {
      throw err;
    }
  }
};
